import React from 'react';
import { CellProps } from 'react-table';
import { BaseRow, InputCellProps } from './helpers';
import useInput from '../../../hooks/useInput';

const TextInputCell = <T extends BaseRow>({
    value,
    onSubmit,
    placeholder,
    disabled,
}: CellProps<T> & InputCellProps<string>) => {
    const inputProps = useInput({ initialValue: value, onSubmit });
    return <input placeholder={placeholder} disabled={disabled} {...inputProps} />;
};

export default TextInputCell;
